module.exports = __webpack_public_path__ + "static/media/28a North South.56a3fa77.jpg";